<app-modal
  height="100%"
  width="100%"
  [compact]="true"
  class="cx-entry-modal"
  [alwaysRender]="true"
>
  <ng-template>
    <iframe
      #entryIframe
      [src]="environment.cxEntryUrl | safe:'resourceUrl'"
      frameborder="0"
      class="full-width d-flex full-height"
    ></iframe>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Close' | trans:'cx-entry/cx-entry-modal/close.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
